import { themeMaterial } from "ag-grid-enterprise";
import { fontMonoFamily } from "../theme/Fonts.css";
import { primitiveTokens, semanticThemeTokens } from "../theme/ThemeTokens.css";

export const theme = themeMaterial.withParams({
  // common
  primaryColor: semanticThemeTokens.dataTable.primaryColor,
  backgroundColor: semanticThemeTokens.dataTable.backgroundColor,
  textColor: semanticThemeTokens.color.textColor,
  fontFamily: fontMonoFamily,
  fontSize: primitiveTokens.type.sm,
  borderColor: semanticThemeTokens.dataTable.borderColor,
  borderRadius: primitiveTokens.sizing["2x"],

  // wrapper
  wrapperBorderRadius: primitiveTokens.sizing["2x"],
  wrapperBorder: {
    color: semanticThemeTokens.dataTable.borderColor
  },

  // header
  headerBackgroundColor: semanticThemeTokens.dataTable.headerBackgroundColor,
  headerColumnBorder: {
    color: semanticThemeTokens.dataTable.borderColor,
    width: "2px"
  },
  headerTextColor: semanticThemeTokens.color.textColor,
  headerColumnBorderHeight: "50%",

  // row
  rowBorder: {
    color: semanticThemeTokens.dataTable.row.borderColor
  },
  oddRowBackgroundColor: semanticThemeTokens.dataTable.row.backgroundColorOdd,
  selectedRowBackgroundColor:
    semanticThemeTokens.dataTable.row.selected.backgroundColor,
  rowHoverColor: semanticThemeTokens.dataTable.row.hover.backgroundColor,
  columnHoverColor: semanticThemeTokens.dataTable.row.hover.backgroundColor,

  // cell
  cellHorizontalPadding: primitiveTokens.sizing["2x"],

  // checkbox
  checkboxUncheckedBackgroundColor:
    semanticThemeTokens.checkbox.unchecked.backgroundColor,
  checkboxUncheckedBorderColor:
    semanticThemeTokens.checkbox.unchecked.default.borderColor,
  checkboxCheckedBackgroundColor:
    semanticThemeTokens.checkbox.checked.backgroundColor,
  checkboxBorderWidth: primitiveTokens.strokes.md,
  checkboxBorderRadius: primitiveTokens.sizing["1x"],
  checkboxCheckedShapeColor:
    semanticThemeTokens.checkbox.checked.checkmarkColor,
  checkboxIndeterminateBackgroundColor:
    semanticThemeTokens.checkbox.checked.backgroundColor,
  checkboxIndeterminateShapeColor:
    semanticThemeTokens.checkbox.checked.checkmarkColor,

  // button
  buttonBackgroundColor:
    semanticThemeTokens.button.secondary.default.backgroundColor,
  buttonTextColor: semanticThemeTokens.button.secondary.textColor,
  buttonHoverBackgroundColor:
    semanticThemeTokens.button.secondary.hover.backgroundColor,
  buttonActiveBackgroundColor:
    semanticThemeTokens.button.secondary.active.backgroundColor,
  buttonDisabledBackgroundColor:
    semanticThemeTokens.button.secondary.disabled.backgroundColor,
  buttonDisabledBorder: {
    color: semanticThemeTokens.button.secondary.disabled.borderColor
  },
  buttonDisabledTextColor:
    semanticThemeTokens.button.secondary.disabled.textColor,

  // input
  inputBorder: {
    color: semanticThemeTokens.input.filled.default.borderColor,
    width: primitiveTokens.strokes.md
  },
  inputFocusBorder: {
    color: semanticThemeTokens.input.filled.active.borderColor,
    width: primitiveTokens.strokes.md
  },

  // toggle (switch)
  toggleButtonOffBackgroundColor:
    semanticThemeTokens.switch.backgroundColor.default.untoggled,
  toggleButtonOnBackgroundColor:
    semanticThemeTokens.switch.backgroundColor.default.toggled,
  toggleButtonSwitchBackgroundColor:
    semanticThemeTokens.switch.thumb.backgroundColor,

  // menu
  menuTextColor: semanticThemeTokens.color.textColor,
  menuBackgroundColor: semanticThemeTokens.dataTable.dropdown.backgroundColor,
  menuShadow: primitiveTokens.colors.shadow.popover,

  // picker
  pickerListBackgroundColor:
    semanticThemeTokens.dataTable.dropdown.backgroundColor,

  // panel
  panelBackgroundColor: semanticThemeTokens.dataTable.dropdown.backgroundColor,
  panelTitleBarIconColor: semanticThemeTokens.color.textColor,

  // side panel
  sidePanelBorder: {
    color: semanticThemeTokens.dataTable.borderColor
  },
  sideButtonSelectedUnderlineColor: semanticThemeTokens.color.textColor,

  // status bar
  statusBarLabelColor: semanticThemeTokens.color.textColor,
  statusBarValueColor: semanticThemeTokens.color.textColor
});
